import React from "react";
import { useParams } from "react-router";
import {
	useBlockUser,
	useCloseContentReport,
	useDeleteComment,
	useGetContentReportById,
} from "../../../queryHooks";
import Breadcrumbs from "../../common/breadcrumbs";
import { useEffect } from "react";
import { URL } from "../../../constants/URL";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CS from "../../../services/commonService";
import RenderUser from "../../common/User";
import { Link } from "react-router-dom";
import { useStore } from "../../../zustand/store";
import swal from "sweetalert2";

const ReportDetails = () => {
	const { slug } = useParams();
	const setLoading = useStore((state) => state.setLoading);

	const {
		data: contentReportData,
		isLoading,
		refetch,
	} = useGetContentReportById(slug);

	const {
		mutateAsync: blockUser,
		error: errorBlockUser,
		data: dataBlockUser,
		isLoading: blockUserLoading,
	} = useBlockUser();

	useEffect(() => {
		if (dataBlockUser) {
			setLoading(false);
			if (dataBlockUser?.status === "success") {
				CS.showSuccessMessage(dataBlockUser?.message);
				refetch();
				setTimeout(() => {
					closeReportOnActionHandler();
				}, 2500);
			} else if (dataBlockUser?.status === "fail") {
				CS.showErrorMessage(dataBlockUser?.message);
			}
		}
	}, [dataBlockUser]);

	useEffect(() => {
		if (errorBlockUser) {
			setLoading(false);
			CS.showErrorMessage(errorBlockUser?.response?.data?.message);
		}
	}, [errorBlockUser]);

	const handleDeactivateUser = () => {
		swal
			.fire({
				text: "Are you sure, you want to deactivate this user?",
				// text: `You won't be able to revert this!`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, deactivate it!",
			})
			.then((result) => {
				if (result?.isConfirmed) {
					blockUser(contentReportData?.data?.reportee?.id);
				}
			});
	};

	const {
		data: closeReportData,
		mutateAsync: closeReportApi,
		error: errorCloseReportData,
		isLoading: closeReportLoading,
	} = useCloseContentReport();

	useEffect(() => {
		if (closeReportData) {
			setLoading(false);
			if (closeReportData?.status === "success") {
				CS.showSuccessMessage(closeReportData?.message);
				refetch();
			} else if (closeReportData?.status === "fail") {
				CS.showErrorMessage(closeReportData?.message);
			}
		}
	}, [closeReportData]);

	useEffect(() => {
		if (errorCloseReportData) {
			setLoading(false);
			CS.showErrorMessage(errorCloseReportData?.response?.data?.message);
		}
	}, [errorCloseReportData]);

	const handleCloseReport = () => {
		swal
			.fire({
				text: "Are you sure, you want to close this report?",
				// text: `You won't be able to revert this!`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, close it!",
			})
			.then((result) => {
				if (result?.isConfirmed) {
					closeReportApi({
						reportId: contentReportData?.data?.id,
						body: { status: "CLOSED" },
					});
				}
			});
	};

	const closeReportOnActionHandler = () => {
		swal
			.fire({
				text: "Would you like to close this report?",
				// text: `You won't be able to revert this!`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, close it!",
			})
			.then((result) => {
				if (result.isConfirmed) {
					closeReportApi({
						reportId: contentReportData?.data?.id,
						body: { status: "CLOSED" },
					});
				}
			});
	};

	const {
		mutateAsync: deleteCommentApi,
		data: deleteCommentData,
		error: errorDeleteComment,
		isLoading: deleteCommentLoading,
	} = useDeleteComment();

	useEffect(() => {
		if (deleteCommentData) {
			setLoading(false);
			if (deleteCommentData?.status === "success") {
				CS.showSuccessMessage(deleteCommentData?.message);
				refetch();
				setTimeout(() => {
					closeReportOnActionHandler();
				}, 2500);
			} else if (deleteCommentData?.status === "fail") {
				CS.showErrorMessage(deleteCommentData?.message);
			}
		}
	}, [deleteCommentData]);

	useEffect(() => {
		if (errorDeleteComment) {
			setLoading(false);
			CS.showErrorMessage(errorDeleteComment?.response?.data?.message);
		}
	}, [errorDeleteComment]);

	const handleDeleteComment = () => {
		swal
			.fire({
				text: "Are you sure, you want to delete this comment?",
				// text: `You won't be able to revert this!`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, delete it!",
			})
			.then((result) => {
				if (result?.isConfirmed) {
					deleteCommentApi({
						timelineId: contentReportData?.data?.params?.timeline_id,
						commentId: contentReportData?.data?.params?.comment_id,
					});
				}
			});
	};

	useEffect(() => {
		setLoading(
			isLoading ||
				blockUserLoading ||
				closeReportLoading ||
				deleteCommentLoading
		);
	}, [isLoading, blockUserLoading, closeReportLoading, deleteCommentLoading]);

	return (
		<>
			<Breadcrumbs
				title="Content Reporting"
				data={[
					{ label: "Content Reports", path: URL.contentReporting },
					{ label: "View Content Report" },
				]}
			/>
			<div className="content-wrapper order-details-wrap">
				<div className="d-flex justify-content-end w-100 mb-2">
					{contentReportData?.data?.status !== "CLOSED" && (
						<button className="btn btn-primary" onClick={handleCloseReport}>
							Close Report
						</button>
					)}
				</div>
				<div className="card p-0">
					<div className="card-body">
						<div className="form-group row">
							<div className="col-md-6">
								<div className="card-box">
									<div className="card-items">
										<h6>Basic Information</h6>
										<p>Reporter</p>
										<div className="profile-info" style={{ marginBottom: 5 }}>
											<Link
												to={`${URL.onboarderedUsers}/${contentReportData?.data?.reporter?.id}`}
												onClick={() => {}}
											>
												<RenderUser
													profileImageUrl={
														contentReportData?.data?.reporter?.profile_image_url
													}
													firstName={
														contentReportData?.data?.reporter?.first_name
													}
													lastName={
														contentReportData?.data?.reporter?.last_name
													}
												/>
											</Link>
										</div>
										<p>
											Type :{" "}
											<strong>
												{contentReportData?.data?.report_type?.label}
											</strong>
										</p>
										<p>
											Reason :{" "}
											<strong>
												{contentReportData?.data?.report_reason?.label}
											</strong>
										</p>
										<p>
											Status :{" "}
											<p
												className={`badge badge-light-${
													contentReportData?.data?.status === "OPEN"
														? "warning"
														: "success"
												}`}
											>
												{contentReportData?.data?.status}
											</p>
										</p>
										<p>
											Created At :{" "}
											<strong>
												{getCurrentTimezoneDate(
													contentReportData?.data?.created_at || "-"
												)}
											</strong>
										</p>
										<p>
											Resolved At :{" "}
											<strong>
												{contentReportData?.data?.resolved_at
													? getCurrentTimezoneDate(
															contentReportData?.data?.resolved_at
													  )
													: "N.A."}
											</strong>
										</p>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="card-box">
									<div className="card-items pb-2">
										<h6>Content Information </h6>
										<p>Reportee</p>
										<div className="profile-info" style={{ marginBottom: 5 }}>
											<Link
												to={`${URL.onboarderedUsers}/${contentReportData?.data?.reportee?.id}`}
												onClick={() => {}}
											>
												<RenderUser
													profileImageUrl={
														contentReportData?.data?.reportee?.profile_image_url
													}
													firstName={
														contentReportData?.data?.reportee?.first_name
													}
													lastName={
														contentReportData?.data?.reportee?.last_name
													}
												/>
											</Link>
										</div>
										{contentReportData?.data?.report_type?.code ===
											"profile" && (
											<>
												<div style={{ marginBottom: 5 }}>
													Profile Image :{" "}
													{CS.renderImageUrl(
														contentReportData?.data?.params?.profile_image_url
													)}
												</div>
												<p>
													Bio :{" "}
													<strong>
														{contentReportData?.data?.params?.bio}
													</strong>
												</p>
											</>
										)}
										{contentReportData?.data?.report_type?.code ===
											"comment" && (
											<>
												<p>
													Comment :{" "}
													<strong>
														{contentReportData?.data?.params?.comment}
													</strong>
												</p>
											</>
										)}
										<p>
											Report Message :{" "}
											<strong>{contentReportData?.data?.message}</strong>
										</p>
										{contentReportData?.data?.status === "OPEN" && (
											<div style={{ marginTop: 10 }}>
												{contentReportData?.data?.report_type?.code ===
													"profile" && (
													<button
														className="btn btn-danger"
														onClick={handleDeactivateUser}
													>
														Deactivate User
													</button>
												)}
												{contentReportData?.data?.report_type?.code ===
													"comment" && (
													<button
														className="btn btn-danger"
														onClick={handleDeleteComment}
													>
														Delete Comment
													</button>
												)}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ReportDetails;
